/**
 * Known feature flag keys. Use these instead of string literals so keys stay in sync with LaunchDarkly.
 */
export enum FeatureFlagKey {
  ENABLEFAAPP = 'enableFAApp',
  ENABLEASKNAVI = 'enableAskNavi',
  ENABLEFINANCIALSNAPSHOT = 'enableFinancialSnapshot',
  ENABLECREDITOVERVIEW = 'enableCreditOverview',
  /** FA Accounts tab (inventory list). Off by default until LaunchDarkly is wired. */
  ENABLEACCOUNTSTAB = 'enableAccountsTab',
  /** FA Review tab (`bn-review-tab`). Off by default until LaunchDarkly is wired. */
  ENABLEAIREVIEW = 'enableAiReview',
  /** Rebuild Activity in the Review dialog. Off by default until LaunchDarkly is wired. */
  ENABLEREBUILDACTIVITY = 'enableRebuildActivity',
  /** Care Plan tab (case lifecycle + client goals, MW-11141). Non-deployable frontend foundation — keep off outside dev/test. */
  ENABLECAREPLAN = 'enableCarePlan',
  /** Client goals across Care Plan. Hidden until explicitly enabled. */
  ENABLECLIENTGOALS = 'enableClientGoals',
  /** BrightNav Home / dashboard. Off by default until LaunchDarkly is wired. */
  ENABLEHOMEPAGE = 'enableHomePage',
}
